<template>
  <div class="box bg_white">
    <div class="rightBox bg_white fl tc">
      <img src="/data/manage/images/comm/logo.png" style="width: 150px;height: auto" alt="" />
      <div>
        <img class="fl" src="/data/manage/images/comm/icon_account.png" alt="" />
        <div class="overflow_hidden f14 txt_AAA">
          <form onsubmit="return false;">
            <input type="text" placeholder="账号..." v-model="phone" autocomplete="off"  @keyup.enter="loginEvent" />
          </form>
        </div>
      </div>
      <div>
        <img class="fl" src="/data/manage/images/comm/icon_password.png" alt="" />
        <div class="overflow_hidden f14 txt_AAA">
          <form onsubmit="return false;">
            <input type="password" name="password" placeholder="密码..." v-model="password" autocomplete="off" @keyup.enter="loginEvent" />
          </form>
        </div>
      </div>
      <button class="tc bg_E91E63 txt_white f15 ffPMP w100 buttonLogin cursor_pointer" @click="loginEvent">登录</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "login",
    data() {
      return {
        phone: '',
        password: '',
      }
    },
    created() {
      this.init();
    },
    methods:{
      init() {
        let phone = window.localStorage.getItem('phone');
        let password = window.localStorage.getItem('password');
        if(phone && password){
          this.phone = phone;
          this.password = password;
        }
      },
      loginEvent() {
        if(!this.phone || !this.password){
          this.$modal({content: '务必填写账号和密码'});
          return;
        }
        this.$api.post('/manage/login',{
          phone: this.phone,
          password: this.password
        }).then((data) => {
          let role = this.$config.roleType.get(data.type);
          if(role !== 'partner') {
            this.$alert.error({content: '只支持合伙人账号'});
            return;
          }
          let loginTime = new Date().getTime();
          this.$store.commit('user/setLogin',{status: true,phone : this.phone,password: this.password,role: role,
            token: data.token,loginTime: loginTime});
          this.$router.push({path: '/partnerWithdrawal'});
        }).catch((error) => {
          this.$alert.error({content: '登录出错:' + error});
        })
      }
    }
  }
</script>

<style scoped>
  .box{
    width: 100%;
    height: 100%;
  }
  input{
    outline: medium;
  }
  .rightBox{
    width: 100%;
    height: 100%;
    padding: 20px;
  }
  .rightBox>div{
    margin-top: 38px;
  }
  .rightBox>div{
    height: 36px;
    border-bottom: 3px #E91E63 solid;
  }
  .rightBox>div>img{
    margin-right: 17px;
  }
  .rightBox>div>div input{
    width: 100%;
    height: 24px;
    line-height: 24px;
  }
  .buttonLogin{
    height: 38px;
    line-height: 38px;
    margin-top: 60px;
  }
</style>
